import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  addCoodBookOptions,
  deletecodebook,
  getAllCodeBook,
  getAllCodeBookOptions,
  updateCoodBookOptions,
  getCodebookOptionsByType,
} from "../../Api/services/code-BookService";

const codebookSlice = createSlice({
  name: "codebook",
  initialState: {
    codeBookData: [],
    codeBookOptionsData: [],
    error: null,
    loading: false,
    //   codebooks by type
    violationTypeOptions: [],
    benefitOptions: [],
    contractTypeOptions: [],
    measureTypeOptions: [],
    userDisciplinaryMeasures: [],
    userBenefits: [],
    relationshipOptions: [],
    maritalStatusOptions: [],
    housingSituationOptions: [],
    genderOptions: [],
    degreeOptions: [],
    areaOptions: [],
    issuedByOptions: [],
    educationTypeOptions: [],
    levelOptions: [],
    languageOptions: [],
    permitTypeOptions: [],
    leaveTypeOptions: [],
  },
  extraReducers: (builder) => {
    //get codebook list
    builder
      .addCase(getAllCodeBook.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllCodeBook.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        }
        return {
          ...state,
          codeBookData: action.payload,
          loading: false,
        };
      })
      .addCase(getAllCodeBook.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //get Languages list
    builder
      .addCase(getAllCodeBookOptions.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllCodeBookOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        }
        return {
          ...state,
          codeBookOptionsData: action.payload,
          loading: false,
        };
      })
      .addCase(getAllCodeBookOptions.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //add codebook options
    builder
      .addCase(addCoodBookOptions.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addCoodBookOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addCoodBookOptions.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //update codebook
    //add codebook options
    builder
      .addCase(updateCoodBookOptions.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateCoodBookOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateCoodBookOptions.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //delete codebook

    builder
      .addCase(deletecodebook.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deletecodebook.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deletecodebook.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //   get codebook options by type
    builder.addCase(getCodebookOptionsByType.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(getCodebookOptionsByType.fulfilled, (state, action) => {
      const {
        type,
        data: { data },
      } = action.payload;
      state.loading = false;

      // Separate state handling based on the type
      if (type === "benefit") {
        state.benefitOptions = data;
      } else if (type === "contract_type") {
        state.contractTypeOptions = data;
      } else if (type === "educational_qualification") {
        //   find in org-structure and replace
      } else if (type === "foreign_language") {
        //   find in org-structure and replace
        state.languageOptions = data;
      } else if (type === "gender") {
        state.genderOptions = data;
      } else if (type === "housing_situation") {
        state.housingSituationOptions = data;
      } else if (type === "leave_duration") {
        //   find in org-structure and replace
      } else if (type === "leave_type") {
        state.leaveTypeOptions = data;
      } else if (type === "marital_status") {
        state.maritalStatusOptions = data;
      } else if (type === "disciplinary_measure_type") {
        state.measureTypeOptions = data;
      } else if (type === "relationship") {
        state.relationshipOptions = data;
      } else if (type === "required_knowledge_and_skill") {
        //   find in org-structure and replace
      } else if (type === "disciplinary_violation_type") {
        state.violationTypeOptions = data;
      } else if (type === "degree") {
        state.degreeOptions = data;
      } else if (type === "issued_by") {
        state.issuedByOptions = data;
      } else if (type === "level") {
        state.levelOptions = data;
      } else if (type === "area") {
        state.areaOptions = data;
      } else if (type === "education_type") {
        state.educationTypeOptions = data;
      } else if (type === "permit_type") {
        state.permitTypeOptions = data;
      }
    });

    builder.addCase(getCodebookOptionsByType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default codebookSlice.reducer;
